// extracted by mini-css-extract-plugin
module.exports = {"container":"NavbarButtonWithMenu_container__LLmRq","actionIcon":"NavbarButtonWithMenu_actionIcon__WoCNE","icon":"NavbarButtonWithMenu_icon__2HNpX"};